import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './css/servicepage.css';

const servicesData = {
  'camarero-digital': {
    title: 'Camarero Digital',
    image: '/assets/images/camarera5-816x816.png',
    description: 'Desarrollamos tu asistai digital personalizado con Inteligencia Artificial para optimizar la atención en tu restaurante.'
  },
  'atencion-ciudadano': {
    title: 'Atención Ciudadano',
    image: '/assets/images/ciudadano-816x825.jpg',
    description: 'Ofrecemos información genérica para el ciudadano a través de asistentes digitales en servicios públicos.'
  },
  'entrevistador': {
    title: 'Entrevistador',
    image: '/assets/images/entrevistador4-2-816x816.png',
    description: 'Prepárate para tus entrevistas de trabajo con nuestro asistai que simula procesos de selección reales.'
  },
  'asistente-personal': {
    title: 'Asistente Personal',
    image: '/assets/images/aistente1-816x816.png',
    description: 'Gestiona tu agenda, reuniones y tareas cotidianas con nuestro asistai personal.'
  },
  'ayudante-banca': {
    title: 'Ayudante Banca',
    image: '/assets/images/asistente11-816x816.png',
    description: 'Facilita los trámites bancarios a personas mayores con nuestro asistai bancario.'
  },
  'asistente-compras': {
    title: 'Asistente Compras',
    image: '/assets/images/dependienta1-816x816.png',
    description: 'Optimiza las compras online de tus clientes con un asistai que guía el proceso de selección.'
  },
  'cita-medica': {
    title: 'Cita Médica',
    image: '/assets/images/dentista1-816x816.png',
    description: 'Gestiona citas médicas y recordatorios con nuestro asistai especializado en salud.'
  },
  'gastroweb': {
    title: 'GastroWeb',
    image: '/assets/images/reservations1-816x816.png',
    description: 'Ofrece reservas en restaurantes y pedidos a domicilio con asistencia digital inteligente.'
  }
};

const ServicePage = () => {
  const { slug } = useParams();
  const service = servicesData[slug];

  if (!service) {
    return (
      <div className="service-page">
        <h2>Servicio no encontrado</h2>
        <Link to="/">Volver al inicio</Link>
      </div>
    );
  }

  return (
    <div className="service-page">
      <div className="service-hero reveal">
        <img src={service.image} alt={service.title} className="service-hero-img" />
        <h1 className="service-title">{service.title}</h1>
      </div>
      <div className="service-content reveal">
        <p>{service.description}</p>
      </div>
      <div className="service-back">
        <Link to="/#servicios">← Volver a Servicios</Link>
      </div>
    </div>
  );
};

export default ServicePage; 